class VariantProperty {
  constructor({value, name, imageUrl, isSelected}) {
    this.value = value;
    this.name = name;
    this.imageUrl = imageUrl;
    this.isSelected = isSelected;
  }

  equals(other) {
    return this.value === other.value && this.name === other.name;
  }

  hashCode() {
    return 0;
  }
}

export default VariantProperty;
